import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

export default function isPushSupportedInCurrentiOSAppVersion() {
  return isNativeAppiOS() && navigator.userAgent.includes("Push");
}
